import React, {useEffect, useState, useContext} from 'react';
import CheckField from '../../CheckField2/CheckField'
// import Required from "../../Required";
// import Checkbox from "../../Checkbox";
// import { Field } from "formik";
// import RadioButtonGroup from "../../RadioButtonGroup";
// import RadioButton from "../../RadioButton";
import './styles.scss'
// import infoCircle from '../../styles/assets/info-circle.png'
// import Popover from '../../../../../formik/refactorOut/components/Popper/Popover.js'
// import { popoverLocation } from "../../../../../config/Configuration";
import {SectionHeader} from '../../sectionHeader/sectionHeader'
// import TextField from '../../TextField/TextField'
// import TextField_NoLogic from '../../TextField/TextField_NoLogic'
import TextField_Custom from '../../TextField/TextField_Custom'
import ErrorBar from '../../ErrorBar'
import { ConfigContext } from '../../../screens/form/DynamicForm/DynamicForm'

const Facilities_NameAddressDoc = ({ formik, template, config, orgId, formColor }) => {
    
    // state values
    const [facilities, setFacilities] = useState([]);
    const [validation, setValidation] = useState({ state: false, message: '' });
    const [facilitiesError, setFacilitiesError] = useState({ state: false, message: '' });


    // sets up context
    let appContext = useContext(ConfigContext)
    appContext.localValues = {};
    appContext.localValues.facilityList = facilities;



    useEffect(() => {
        formik.setFieldValue("setfacilityPreList", ["Carbon Health", '','','','']); // hard code default facility
    }, []);

    // copy over to facility list
    useEffect(() => {
        if (formik.values.setfacilityPreList) {
            let facilityListOut = [];
            for (var i = 0; i < formik.values.setfacilityPreList.length; i++) {
                if (formik.values.setfacilityPreList[i] !== '') {
                    facilityListOut.push(formik.values.setfacilityPreList[i]);
                }
            }
            formik.setFieldValue("facilityList", facilityListOut);
            setFacilities(facilityListOut);
        }
    }, [formik.values.setfacilityPreList]);

    
    // when there is an error on a single facility, set an overall error on facilities component
    useEffect(()=>{
        appContext.localError = facilitiesError.state;
    }, [facilitiesError])
    
    // when formik facility list is changed, update facilityOrPhysician accordingly
    useEffect(() => {
        if (Object.values(formik.values.facilityList).every((value)=>{ return value.length == 0 })) {
            formik.setFieldValue('facilityOrPhysician', "")
        }
        else {
            formik.setFieldValue('facilityOrPhysician', "on")
        }
    }, [formik.values.facilityList])
    
    return (
        <>
            <div id='medicalFacilitiesRequested' className='form-section carbon7307-form-section'>
                <SectionHeader sectionTitle={'Facilities Releasing Information'} styles={{color: formColor}}/>
                
                {validation.state && <ErrorBar message={validation.message} />}
                {formik.errors.facilityOrPhysician && formik.touched.facilityOrPhysician && <ErrorBar message={formik.errors.facilityOrPhysician} />}
                <label className='section-instruction subtitle1'>
                    Specify the facilities you authorize to release the requested records
                </label>
                <CheckField checkboxType={'release'} formik={formik} formValue={'item.key'} checkItemLabel={'Carbon Health'} tooltip={false} trueFormSpec={appContext.dbFormSpec} decorative={true}/>
                <hr />
                
                <div className='facility-options'>        
                    <ThreeLevelFacilityForm setFacilitiesError={setFacilitiesError} set={'1'}/>
                    <ThreeLevelFacilityForm setFacilitiesError={setFacilitiesError} set={'2'}/>
                    <ThreeLevelFacilityForm setFacilitiesError={setFacilitiesError} set={'3'}/>
                    <ThreeLevelFacilityForm setFacilitiesError={setFacilitiesError} set={'4'}/>
                </div>
            </div>
        </>
    )
}

export default Facilities_NameAddressDoc;


const DecorativeCheckbox = (props) => {
    
    return (
        <div className='decorative-checkbox'>
            <input type="checkbox" className='7227-checkbox checkbox' checked={props.checked} onChange={props.onChange} /> 
            <label className='decorative-checkbox-label' style={{...props.labelStyle, fontWeight:600}}>{props.label}</label>
        </div>
    )
}

const ThreeLevelFacilityForm = ({setFacilitiesError, set}) => {

    // state values
    const [error, setError] = useState({state: false, message: ''})
    const [enteredValues, setEnteredValues] = useState({
        facility_name: '',
        facility_address: '',
        facility_doctor: '',
        textGroupID: ''
    });

   

    // context values
    const {formik, setLocalError} = useContext(ConfigContext);
    
    // local variables
    const requiredFields = [enteredValues.facility_name, enteredValues.facility_address]
    
    // Sets error on this component, which is passed down to the individual fields
    // Sets the value of formik.values.facilityList every time enteredValues changes
    useEffect(() => {
        requiredFields.some((value)=>{ return value.length > 0 }) && requiredFields.some((value)=>{ return value.length == 0 }) ? setError({state: true, message: 'blah'}) : setError({state: false, message: 'blah'})
        // if every property on enteredValues is empty...

        if (enteredValues.facility_address && enteredValues.facility_name) {
            let facilityFreeText = [enteredValues.facility_name, enteredValues.facility_address,  enteredValues.facility_doctor].join(",");

            formik.setFieldValue(`setfacilityPreList[${enteredValues.textGroupID}]`, facilityFreeText);
        } else {
            formik.setFieldValue(`setfacilityPreList[${enteredValues.textGroupID}]`, '');            
        }


    }, [enteredValues])
    
    // Sets error on parent component
    useEffect(()=>{
        console.log('COMPONENTERROR', error)
        error.state ? setFacilitiesError({state: true, message: error.message}) : setFacilitiesError({state: false, message: ''})
        error.state ? setLocalError(true) : setLocalError(false)
    }, [error])
    
    return (
        <div className="threelevelfacilityform">
            <label htmlFor="" className='label'>Facility {set}</label>
            <div className="input-fields">
                <TextField_Custom fieldId={'facility_name'} cssField={'css-field'} label={'Facility Name'} maxLength={100} variant={'7307_facility'} fieldIsRequired={true} stateProps={{ setEnteredValues: setEnteredValues, enteredValues: enteredValues, error: error, setError: setError, errorMessage: 'Please provide a facility name' }} settextGroupID={set} />
                <TextField_Custom fieldId={'facility_address'} cssField={'css-field'} label={'Facility Address'} maxLength={100} variant={'7307_facility'} fieldIsRequired={true} stateProps={{ setEnteredValues: setEnteredValues, enteredValues: enteredValues, error: error, setError: setError, errorMessage: 'Please provide a facility address' }} settextGroupID={set} />
                <TextField_Custom fieldId={'facility_doctor'} cssField={'css-field'} label={"Doctor's Name (Optional)"} maxLength={100} variant={'7307_facility'} fieldIsRequired={false} stateProps={{ setEnteredValues: setEnteredValues, enteredValues: enteredValues, error: error, setError: setError }} settextGroupID={set} />
            </div>
        </div>
    );
}


